Group.create = function (node, superGroup) {
    var group = new Group();

    if (superGroup) {
        group.label = Utils.getNextDefaultLabel(superGroup.subGroups, "Group", 1);
        group.id = Utils.getNextDefaultId(superGroup.subGroups, "group", 1);
    }
    else {
        group.label = Utils.getNextDefaultLabel(node.groups, "Group", 1);
        group.id = Utils.getNextDefaultId(node.groups, "group", 1);
    }

    icon: "icon sl-house-1";
    group.devices = [];
    group.actors = [];
    group.sensors = [];
    group.services = [];

    group.bind(node, superGroup);

    return group;
};

Group.bind = function (node, group, superGroup) {
    Utils.inheritMethods(group, new Group());

    group.bind(node, superGroup);

    return group;
};

function Group() {
    /**
     *
     */
    Group.prototype.bind = function (node, superGroup) {
        this.class = "Group";
        this.__node = node;
        this.__superGroup = superGroup;

        if (!this.subGroups) {
            this.subGroups = [];
        }

        for (var n in this.subGroups) {
            Utils.inheritMethods(this.subGroups[n], new Group());

            this.subGroups[n].bind(node, this);
        }

        this.__devices = [];

        for (var n in this.devices) {
            var device = node.getDevice(this.devices[n]);

            this.__devices.push(device);
            device.__inGroup = true;
        }

        this.__actors = [];

        for (var n in this.actors) {
            var path = this.actors[n].split(".");

            this.__actors.push(node.getDevice(path[0]).getActor(
                path[1]));
        }

        this.__sensors = [];

        for (var n in this.sensors) {
            var path = this.sensors[n].split(".");

            this.__sensors.push(node.getDevice(path[0]).getSensor(
                path[1]));
        }

        if (!this.services) {
            this.services = [];
        }

        this.__services = [];

        for (n in this.services) {
            this.__services.push(node.getService(this.services[n]));
        }
    };

    /**
     *
     */
    Group.prototype.path = function () {
        return !this.__superGroup ? this.id : this.__superGroup.path() + "." + this.id;
    };

    /**
     *
     */
    Group.prototype.getSubGroup = function (id) {
        for (var n in this.subGroups) {
            if (this.subGroups[n].id == id) {
                return this.subGroups[n];
            }
        }

        throw "No Subgroup with id [" + id + "]";
    };

    /**
     *
     */
    Group.prototype.replaceSubGroup = function (group) {
        for (var n in this.subGroups) {
            if (this.subGroups[n].id == group.id) {
                this.subGroups[n] = group;

                return;
            }
        }

        throw "No Subgroup with id [" + group.id + "]";
    };

    /**
     *
     */
    Group.prototype.getAllGroups = function () {
        var groups = [];

        for (var n in this.subGroups) {
            groups.push.apply(groups, this.subGroups[n]
                .getAllGroups());
            groups.push(this.subGroups[n]);
        }

        return groups;
    };

    /**
     *
     */
    Group.prototype.containsSensor = function (sensor) {
        for (var n in this.sensors) {
            if (this.sensors[n] === sensor.fullId()) {
                return true;
            }
        }

        for (var n in this.subGroups) {
            if (this.subGroups[n].containsSensor(sensor)) {
                return true;
            }
        }

        return false;
    };

    /**
     *
     */
    Group.prototype.getDevices = function () {
        return this.__devices;
    };

    /**
     *
     */
    Group.prototype.getSensors = function () {
        return this.__sensors;
    };

    /**
     *
     */
    Group.prototype.containsActor = function (actor) {
        for (var n in this.actors) {
            if (this.actors[n] === actor.fullId()) {
                return true;
            }
        }

        for (var n = 0; n < this.subGroups.length; ++n) {
            if (this.subGroups[n].containsActor(actor)) {
                return true;
            }
        }

        return false;
    };

    /**
     *
     */
    Group.prototype.getActors = function () {
        return this.__actors;
    };
}
